export default __webpack_public_path__ + "048cf8848360127f1a2452a2bdd4af9d.png";